
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 3.875l-7 3.5V28h26V7.375l-7-3.5-6 3zm0 2.25l5 2.5V26H5V8.625zm12 0l5 2.5V26H17V8.625zM7 10v2h2v-2zm4 0v2h2v-2zm8 0v2h2v-2zm4 0v2h2v-2zM7 14v2h2v-2zm4 0v2h2v-2zm8 0v2h2v-2zm4 0v2h2v-2zM7 18v2h2v-2zm4 0v2h2v-2zm8 0v2h2v-2zm4 0v2h2v-2zM7 22v2h2v-2zm4 0v2h2v-2zm8 0v2h2v-2zm4 0v2h2v-2z"}})])
          )
        }
      }
    